(function () {
  let controller = null;
  let debounceTimer = null;
  let requestVersion = 0;
  let suggestions = [];
  let activeIndex = -1;

  function getInput() {
    return document.getElementById('store-location-input');
  }

  function getPanel() {
    return document.getElementById('store-location-suggestions');
  }

  async function getAccessToken() {
    if (window.mapboxgl && window.mapboxgl.accessToken) return window.mapboxgl.accessToken;

    if (window.BlsCreateMapStoreLocation && typeof window.BlsCreateMapStoreLocation.loadMap === 'function') {
      try {
        await window.BlsCreateMapStoreLocation.loadMap();
      } catch (error) {}
    }

    return window.mapboxgl && window.mapboxgl.accessToken ? window.mapboxgl.accessToken : '';
  }

  function ensurePanel() {
    const input = getInput();
    if (!input) return null;
    let panel = getPanel();
    if (panel) return panel;
    const wrapper = input.closest('.store-finder__input-wrap');
    if (!wrapper) return null;

    panel = document.createElement('span');
    panel.id = 'store-location-suggestions';
    panel.className = 'store-finder__suggestions';
    panel.setAttribute('role', 'listbox');
    panel.setAttribute('aria-label', 'Locatiesuggesties');
    panel.hidden = true;
    wrapper.appendChild(panel);
    return panel;
  }

  function injectStyles() {
    if (document.getElementById('store-location-autocomplete-styles')) return;
    const style = document.createElement('style');
    style.id = 'store-location-autocomplete-styles';
    style.textContent = `
      .store-finder__input-wrap { position: relative; }
      .store-finder__suggestions {
        position: absolute;
        top: calc(100% + 6px);
        left: 0;
        right: 0;
        z-index: 50;
        display: block;
        max-height: 320px;
        overflow-y: auto;
        padding: 6px 0;
        border: 1px solid #d9d9d9;
        border-radius: 10px;
        background: #fff;
        box-shadow: 0 10px 28px rgba(15, 23, 42, 0.15);
      }
      .store-finder__suggestions[hidden] { display: none !important; }
      .store-finder__suggestion {
        display: block;
        width: 100%;
        padding: 10px 14px;
        cursor: pointer;
        text-align: left;
        background: #fff;
        color: #111;
      }
      .store-finder__suggestion:hover,
      .store-finder__suggestion.is-active {
        background: #f4f5f7;
      }
      .store-finder__suggestion-title {
        display: block;
        font-weight: 600;
        line-height: 1.35;
      }
      .store-finder__suggestion-subtitle {
        display: block;
        margin-top: 2px;
        color: #667085;
        font-size: 13px;
        line-height: 1.35;
      }

      @media (min-width: 992px) {
        .bls__location-page .store-wrapper.large-map .store-map {
          grid-template-areas: none !important;
          grid-template-rows: auto !important;
          align-items: stretch;
        }
        .bls__location-page .store-wrapper.large-map .store-finder {
          display: block !important;
          min-width: 0;
          margin: 0;
          padding: 0;
          border: 0;
          border-radius: 0;
          background: transparent;
        }
        .bls__location-page .store-wrapper.large-map .store-finder__intro {
          grid-area: auto !important;
          margin: 0 0 1.2rem;
        }
        .bls__location-page .store-wrapper.large-map .store-finder__controls {
          grid-area: auto !important;
          align-items: start;
        }
        .bls__location-page .store-wrapper.large-map .store-finder__input-wrap,
        .bls__location-page .store-wrapper.large-map .store-finder__search-button,
        .bls__location-page .store-wrapper.large-map .store-finder__location-button--secondary {
          height: 46px;
          min-height: 46px;
          align-self: start;
        }
        .bls__location-page .store-wrapper.large-map .store-finder__input {
          height: 46px;
          min-height: 46px;
        }
        .bls__location-page .store-wrapper.large-map .store-finder__status {
          grid-area: auto !important;
          margin: .7rem 0 1.6rem;
        }
        .bls__location-page .store-wrapper.large-map .store-distance-results {
          grid-area: auto !important;
          grid-template-columns: 1fr;
          align-content: start;
          gap: 1rem;
          margin: 0;
        }
        .bls__location-page .store-wrapper.large-map .store-map__canvas {
          grid-area: auto !important;
          width: 100%;
          height: 100%;
          min-height: 360px;
          max-height: none;
          align-self: stretch;
        }
      }
    `;
    document.head.appendChild(style);
  }

  function hideSuggestions() {
    window.clearTimeout(debounceTimer);
    const panel = getPanel();
    const input = getInput();
    if (panel) {
      panel.hidden = true;
      panel.replaceChildren();
    }
    suggestions = [];
    activeIndex = -1;
    if (input) {
      input.setAttribute('aria-expanded', 'false');
      input.removeAttribute('aria-activedescendant');
    }
  }

  function setActive(index) {
    const panel = getPanel();
    const input = getInput();
    if (!panel || !input || !suggestions.length) return;
    activeIndex = Math.max(0, Math.min(index, suggestions.length - 1));
    panel.querySelectorAll('.store-finder__suggestion').forEach(function (option, optionIndex) {
      const isActive = optionIndex === activeIndex;
      option.classList.toggle('is-active', isActive);
      option.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });
    input.setAttribute('aria-activedescendant', 'store-location-suggestion-' + activeIndex);
  }

  function useSuggestion(index) {
    const item = suggestions[index];
    const input = getInput();
    if (!item || !input) return;

    requestVersion += 1;
    if (controller) controller.abort();
    input.value = item.label;
    hideSuggestions();

    if (
      window.BlsCreateMapStoreLocation &&
      typeof window.BlsCreateMapStoreLocation.setOrigin === 'function' &&
      Array.isArray(item.coordinates)
    ) {
      window.BlsCreateMapStoreLocation.setOrigin(item.coordinates, item.label, 'suggestion');
    } else if (window.BlsCreateMapStoreLocation && typeof window.BlsCreateMapStoreLocation.searchTypedLocation === 'function') {
      window.BlsCreateMapStoreLocation.searchTypedLocation();
    } else {
      const searchButton = document.getElementById('store-location-search');
      if (searchButton) searchButton.click();
    }
  }

  function renderSuggestions(items) {
    const panel = ensurePanel();
    const input = getInput();
    if (!panel || !input) return;

    suggestions = items;
    activeIndex = -1;
    panel.replaceChildren();

    if (!suggestions.length) {
      hideSuggestions();
      return;
    }

    suggestions.forEach(function (item, index) {
      const option = document.createElement('span');
      option.id = 'store-location-suggestion-' + index;
      option.className = 'store-finder__suggestion';
      option.setAttribute('role', 'option');
      option.setAttribute('aria-selected', 'false');

      const title = document.createElement('span');
      title.className = 'store-finder__suggestion-title';
      title.textContent = item.primary;
      option.appendChild(title);

      if (item.secondary) {
        const subtitle = document.createElement('span');
        subtitle.className = 'store-finder__suggestion-subtitle';
        subtitle.textContent = item.secondary;
        option.appendChild(subtitle);
      }

      option.addEventListener('mousedown', function (event) {
        event.preventDefault();
      });
      option.addEventListener('mouseenter', function () {
        setActive(index);
      });
      option.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        useSuggestion(index);
      });
      panel.appendChild(option);
    });

    panel.hidden = false;
    input.setAttribute('aria-expanded', 'true');
  }

  async function fetchSuggestions(query) {
    const input = getInput();
    if (!input || input.value.trim() !== query) return;

    const currentVersion = ++requestVersion;
    if (controller) controller.abort();
    controller = new AbortController();

    const token = await getAccessToken();
    if (!token || currentVersion !== requestVersion || input.value.trim() !== query) {
      if (!token) hideSuggestions();
      return;
    }

    const params = new URLSearchParams({
      q: query,
      access_token: token,
      country: 'NL',
      language: 'nl',
      limit: '5',
      autocomplete: 'true',
      types: 'address,street,postcode,place,locality,neighborhood'
    });

    try {
      const response = await fetch('https://api.mapbox.com/search/geocode/v6/forward?' + params.toString(), {
        signal: controller.signal
      });
      if (!response.ok) throw new Error('Autocomplete request failed');
      const data = await response.json();
      if (currentVersion !== requestVersion || input.value.trim() !== query) return;

      const items = (Array.isArray(data.features) ? data.features : []).map(function (feature) {
        const properties = feature.properties || {};
        const coordinates = feature.geometry && feature.geometry.coordinates;
        if (!coordinates || coordinates.length < 2) return null;
        const lng = Number(coordinates[0]);
        const lat = Number(coordinates[1]);
        if (!Number.isFinite(lng) || !Number.isFinite(lat)) return null;

        const primary = properties.name_preferred || properties.name || feature.text || '';
        const fullAddress = properties.full_address || feature.place_name || properties.place_formatted || primary;
        let secondary = properties.place_formatted || feature.place_name || '';
        if (!secondary && properties.full_address && properties.full_address !== primary) secondary = properties.full_address;
        if (secondary === primary) secondary = '';

        return {
          label: fullAddress || primary || query,
          primary: primary || fullAddress || query,
          secondary: secondary,
          coordinates: [lng, lat]
        };
      }).filter(Boolean).slice(0, 5);

      renderSuggestions(items);
    } catch (error) {
      if (error.name === 'AbortError' || currentVersion !== requestVersion) return;
      hideSuggestions();
    }
  }

  function queueSuggestions() {
    const input = getInput();
    if (!input) return;
    window.clearTimeout(debounceTimer);
    const query = input.value.trim();
    if (query.length < 2) {
      requestVersion += 1;
      if (controller) controller.abort();
      hideSuggestions();
      return;
    }
    debounceTimer = window.setTimeout(function () {
      fetchSuggestions(query);
    }, 220);
  }

  function init() {
    const input = getInput();
    if (!input || input.dataset.bosAutocompleteReady === 'true') return;
    input.dataset.bosAutocompleteReady = 'true';
    input.setAttribute('autocomplete', 'off');
    input.setAttribute('aria-autocomplete', 'list');
    input.setAttribute('aria-controls', 'store-location-suggestions');
    input.setAttribute('aria-expanded', 'false');

    ensurePanel();
    injectStyles();

    input.addEventListener('input', queueSuggestions);
    input.addEventListener('keydown', function (event) {
      const panel = getPanel();
      const hasVisibleSuggestions = panel && !panel.hidden && suggestions.length;
      if (!hasVisibleSuggestions) return;

      if (event.key === 'ArrowDown') {
        event.preventDefault();
        event.stopImmediatePropagation();
        setActive(activeIndex < suggestions.length - 1 ? activeIndex + 1 : 0);
      } else if (event.key === 'ArrowUp') {
        event.preventDefault();
        event.stopImmediatePropagation();
        setActive(activeIndex > 0 ? activeIndex - 1 : suggestions.length - 1);
      } else if (event.key === 'Enter') {
        event.preventDefault();
        event.stopImmediatePropagation();
        useSuggestion(activeIndex >= 0 ? activeIndex : 0);
      } else if (event.key === 'Escape') {
        event.preventDefault();
        event.stopImmediatePropagation();
        hideSuggestions();
      }
    });

    input.addEventListener('blur', function () {
      window.setTimeout(hideSuggestions, 180);
    });

    const searchButton = document.getElementById('store-location-search');
    if (searchButton) {
      searchButton.addEventListener('click', function (event) {
        const panel = getPanel();
        if (!panel || panel.hidden || !suggestions.length) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        useSuggestion(activeIndex >= 0 ? activeIndex : 0);
      });
    }

    const locationButton = document.getElementById('store-use-location');
    if (locationButton) {
      locationButton.addEventListener('click', function () {
        requestVersion += 1;
        if (controller) controller.abort();
        hideSuggestions();
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
